/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ForumIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABnklEQVR4nN2Vu0oDURCGg6CljYUY9RXEQhBErQPJXLZIZjZB7CLiM0gCFinFgK+QxsoH8AUsRKw13kovaLyggomcVVGT7MnZTefANHtm5mPm/HM2kfi3ViwWB4HVR5Iakpwgy6NxID0238yZiYlVnMgHJDlD1pbNgfUUWDKRigPJOrI2exXHH2+aHLfiLKsRCrd+O5G/Yi3ueYUJIH2ICwDWRjqdHbeNZiNucfyGkJRDAUh62DeA5cAyf230C0CWe8uI9NlJMSy7wJojkslsNjvkeYUxxNwismwj6b6lAznqcYkXRDKXiGtAWrEAzhE1aeKMUpClGiwZ6atZSGDZQdTZnjJF1qcuynhH1BkTQyQLQHoTriKtWCFIsteRSFILzlCTyHLrsA/LISOSctckT9MBgKXquAuXHY+goYYmgI5+xZw67wPo1B8AkeSDC+vU9VWpVBr47EBfnPcBFR101XY/rHVXAFF+OjIASLZcAcxLI9E7QE3aJNomjLVEHMuwPw8k172VpHepVGE4FiR4e1g2zX8aSN5CIPXYgKj2AUPjSDJkRrkUAAAAAElFTkSuQmCC)
 */
export const ForumIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.91 12.98a5.45 5.45 0 0 1 2.18 6.2c-.1.33-.09.68.1.96l.83 1.32a1 1 0 0 1-.84 1.54h-5.5A5.6 5.6 0 0 1 10 17.5a5.6 5.6 0 0 1 5.68-5.5c1.2 0 2.32.36 3.23.98Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19.24 10.86c.32.16.72-.02.74-.38L20 10c0-4.42-4.03-8-9-8s-9 3.58-9 8c0 1.5.47 2.91 1.28 4.11.14.21.12.49-.06.67l-1.51 1.51A1 1 0 0 0 2.4 18h5.1a.5.5 0 0 0 .49-.5c0-4.2 3.5-7.5 7.68-7.5 1.28 0 2.5.3 3.56.86Z"
        className={colorClass}
      />
    </svg>
  );
};
